goog.provide("shadow.js.shim.module$src$svg$wpp$content$map_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$map_svg");
shadow.js.shim.module$src$svg$wpp$content$map_svg = shadow.js.nativeProvides["src/svg/wpp/content/map.svg"] = shadow$bridge("src/svg/wpp/content/map.svg");
module$shadow_js_shim_module$src$svg$wpp$content$map_svg.default = shadow.js.shim.module$src$svg$wpp$content$map_svg;
